import {useMemo} from 'react';
import {
  schemaRefEducationalSeries,
  schemaRefOtherConnection,
  schemaRefPublisherSeries,
  schemaRefSeries,
} from 'schemas/types';
import {useSchemaListCodelistIds} from 'schema';
import {useSchema} from './useSchema';

export const useCollectionsCodelistIds = () => {
  const seriesSchema = useSchema(schemaRefSeries);
  const educationalSeriesSchema = useSchema(schemaRefEducationalSeries);
  const otherConnectionSchema = useSchema(schemaRefOtherConnection);
  const publisherSeriesSchema = useSchema(schemaRefPublisherSeries);

  const collectionSchemas = useMemo(
    () => [
      seriesSchema,
      educationalSeriesSchema,
      otherConnectionSchema,
      publisherSeriesSchema,
    ],
    [
      educationalSeriesSchema,
      otherConnectionSchema,
      publisherSeriesSchema,
      seriesSchema,
    ],
  );

  return useSchemaListCodelistIds(collectionSchemas);
};
